import React from "react";
import {
  faBriefcaseMedical,
  faHeart,
  faUserMd,
} from "@fortawesome/free-solid-svg-icons";
import "../style/About.css";
import "../style/Common.css";
import aboutUs from "../images/More.jpg";
import aboutUsMobile from "../images/doctor-checking.jpg";
import "../style/More.css";
import styles from "../style/stats.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Healthcare from "./Tabs";
import specs from "../images/aligner specs.png";
import { useMediaQuery } from "react-responsive";
  
const More = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  return (
    <section className="more" id="more">
      <div className="about-us-container">
        <div className="about-us-content">
          <h1>Process</h1>
          <nav className="breadcrumb">
            <span>Home</span>
            <span className="separator">|</span>
            <span>Process</span>
          </nav>
        </div>
        <div className="about-us-image">
          {isMobile ? (
            <img src={aboutUsMobile} alt="About Us" className="mobile-image" />
          ) : (
            <img src={aboutUs} alt="About Us" />
          )}
        </div>
      </div>
      <div className="tabs-section" id="tabs-section">
        <Healthcare />
      </div>
      <div className={styles.statsContainer}>
        <div className={styles.stat}>
          <FontAwesomeIcon icon={faHeart} className={styles.icon} />
          <div>
            <h2>10K</h2>
            <p>Happy Customers</p>
          </div>
        </div>
        <div className={styles.stat}>
          <FontAwesomeIcon icon={faUserMd} className={styles.icon} />
          <div>
            <h2>100%</h2>
            <p>Satisfaction</p>
          </div>
        </div>
        <div className={styles.stat}>
          <FontAwesomeIcon icon={faBriefcaseMedical} className={styles.icon} />
          <div>
            <h2>25+</h2>
            <p>Years of experience</p>
          </div>
        </div>
      </div>
      <div className="AlignerSpecs-container">
        <div
          id="aligner-specs"
          style={{
            position: "relative",
            top: "-120px",
            height: "0px",
            overflow: "hidden",
          }}
        />
        <h2 className="instructions-subtitle">
          Lamaan Aligners Material Specs
        </h2>
        <br />
        <h3 className="instructions-title">
          Revolutionary Clear Aligner Material For Ideal Expression
        </h3>
        <div className="instructions-containernogrid">
          <section class="instruction-section">
            <ul>
              <li>
                {" "}
                Lamaan's aligner material is made of polyether-based TPU
                (thermo-plastic polyurethane) with 3-layer structure
              </li>
              <li>
                {" "}
                The sheet features high tensile strength, high modulus, and good
                bio-compatibility, an ideal choice for the production of clear
                aligner
              </li>
              <li>
                The 3-layer solution reaches the balance between the resilience
                needed for easy insertion and take-off and the rigidity needed
                for force persistence and durability
              </li>
              <li>
                Different properties of each layer ensure the ideal force
                expression required by orthodontic treatment
              </li>
              <li>
                Lamaan aligners are German-engineered and manufactured in China
                using a high-quality production process
              </li>
            </ul>
          </section>
        </div>
        <div style={{ textAlign: "center" }}>
          <img src={specs} alt="alignerspecs" className="spec-img" />
        </div>
      </div>
    </section>
  );
};

export default More;
